const firebaseConfig = {
    apiKey: "AIzaSyAjOElptnzgnG_evtR0ZSs7dc9nM8JtdYI",
    authDomain: "react-auth-second-practice.firebaseapp.com",
    projectId: "react-auth-second-practice",
    storageBucket: "react-auth-second-practice.appspot.com",
    messagingSenderId: "202351952627",
    appId: "1:202351952627:web:159eb2bdbbb13639476d86",
    measurementId: "G-L74JF3TTCY"
  };

  export default firebaseConfig;

  